import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormGroupDetails, FormGroupLabelRoot } from './FormGroupLabel.styled';
// Component.
// -----------------------------------------------------------------------------
export const FormGroupLabel = ({ children, details, mode, name, position, size }) => (_jsxs(FormGroupLabelRoot, { htmlFor: name, position: position, size: size, children: [children, details && _jsx(FormGroupDetails, { mode: mode, children: details })] }));
//# sourceMappingURL=FormGroupLabel.js.map